import { render, staticRenderFns } from "./QueryId.vue?vue&type=template&id=24346cdf"
import script from "./QueryId.vue?vue&type=script&lang=js"
export * from "./QueryId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports